const DEFAULT_INPUT_WIDTH = 6;
const DEFAULT_QUESTION_WIDTH = 6;
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// Tabs should grow if there are more than GROW_TABS tabs
const GROW_TABS = 2;
const ZIP_REGEX = /^\d{5}(-\d{4})?$/;

export {
    DEFAULT_QUESTION_WIDTH,
    DEFAULT_INPUT_WIDTH,
    EMAIL_REGEX,
    GROW_TABS,
    ZIP_REGEX
};


// WEBPACK FOOTER //
// ./src/components/constants.js